import React, { useState, Fragment, useEffect, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { Box, styled } from '@mui/material';
import { MenuList } from '../../constants/menu';
import styles from './tabView.module.css';
import { usePageTracking } from 'utils/userPageTracking';
import { useUserAccess } from 'utils/userAccessContext';
import { useRefresh } from "../../../utils/refreshContext";
import newExcel from "./../../../assets/images/FileXls.svg";
import AlertLanding from '../../pages/Alerts/alertLanding';
import DailyphasingContainer from 'Samarth Module/pages/dailyPhasing/DailyphasingContainer';
import { DailyPhasingProvider } from 'utils/dailyphaisngContext/DailyphasingContext';
import RmpmAlertLanding from 'Samarth Module/pages/Alerts/rmpmAlertLanding';
import SupplierInsights from 'Samarth Module/pages/Alerts/supplierInsights';
import DailyPhasingLanding from 'Samarth Module/pages/dailyPhasing/Component/DailyPhasingViews/DailyPhasingLanding';
import DailyProductionInsight from 'Samarth Module/pages/dailyProductionInsight/DailyProductionInsight';
import PriortizationMatrix from "Samarth Module/pages/prioritize/PriortizationMatrix";
import User from 'Samarth Module/pages/adminPortal/User/user';
import Persona from 'Samarth Module/pages/adminPortal/Persona/persona';
import DispatchPriority from 'Samarth Module/pages/quickComm/dispatchPriority/dispatchPriority';
import OrderVisibility from 'Samarth Module/pages/quickComm/orderVisibility/orderVisibility';
import OrLossTree from '../../pages/orLossTree/orLossTree';
import LossRecoveryEngine from 'Samarth Module/pages/PSO/lossRecoveryEngine/lossRecoveryEngine';
import OrderExecuationMonitor from 'Samarth Module/pages/PSO/orderExecuationMonitor/orderExecuationMonitor';
import RMPMSummary from 'Samarth Module/pages/alertSummary/RMPMSummary';
import POPriority from 'Samarth Module/pages/quickComm/POPriority/POPriority';
import CustomButton from '../buttons/CustomButton';
import { handleAllDispatchPriorityExport, handleAllSuggestedOrderExport, handleExportPOPriorityWholeScreen } from 'Samarth Module/api/Qcommapi';
import INTRLossToAction from 'Samarth Module/pages/PSO/LossToAction/intrRcovery/intr';
import UnloadingPriority from 'Samarth Module/pages/PSO/LossToAction/UnloadingPrioritization/unloadingPriority';
import InTransitRecovery from 'Samarth Module/pages/PSO/LossToAction/InTransitRecovery/inTransitRecovery.js';
import DispatchPrioritisation from 'Samarth Module/pages/PSO/LossToAction/DispatchPrioritization/DispatchPrioritization';
import INTRMaterialView from 'Samarth Module/pages/PSO/LossToAction/MaterialView/intrMaterialView';
import RmpmDashboard from 'Samarth Module/pages/fgDemand/FGDemand';
import SmartSourceLens from 'Samarth Module/pages/FDC/smartSourceLens/SmartSourceLens';
import DcSupplyInsights from 'Samarth Module/pages/FDC/dcSupplyInsights/DcSupplyInsights';
import Tickets from 'Samarth Module/pages/ticketPortal/tickets/tickets';
// import DecisionIQChatBot from 'Samarth Module/components/DecisionIQ/DecisionIQ';
const CustomTab = styled(Tab)({
    "&.MuiButtonBase-root": {
        fontSize: "13px",
        fontWeight: 400,
        lineHeight: 1,
        border: "1px solid #f5f5f5",
        background: "lightgrey",
        padding: "0 15px",
        minHeight: "35px",
        textTransform: "capitalize",
        marginRight: "5px",
        borderRadius: "10px 10px 0 0",
        color: "#333333a1",
    },
    "&.Mui-selected": {
        fontWeight: 600,
        padding: "0 15px",
        color: "#fff",
        border: "1px solid #1F36C7",
        background: "#1F36C7",
        borderRadius: "10px 10px 0 0",
    },
});

const CustomSideTab = styled(Tab)({
    "&.MuiButtonBase-root": {
        fontSize: "13px",
        lineHeight: 1,
        padding: "0 12px",
        minHeight: "30px",
        textTransform: "capitalize",
        marginRight: "5px",
        borderRadius: "10px 10px 0 0",
        fontWeight: 400,
        color: "#809FB8",
        border: "1px solid #F1F5F7",
        background: "#F1F5F7",
    },
    "&.Mui-selected": {
        fontWeight: 500,
        padding: "0 15px",
        color: "#1A2025",
        border: "1px solid #F1F5F7",
        background: "#fff",
        borderRadius: "10px 10px 0 0"
    },
});

const CustomTabs = styled(Tabs)({
    "&.MuiTabs-root": { minHeight: "0px" },
    "&.MuiTabs-root .MuiTabs-fixed span": { background: "none" },
});

const CustomTabPanel = ({ children, value, index }) => {
    const isActive = value === index;
    return (
        <div
            role="tabpanel"
            hidden={!isActive}
            key={`tabpanel-${index}`} // Unique key per tab panel
        >
            {isActive && <Fragment>{children}</Fragment>}
        </div>
    );
};
const sideTabs = {
    0: 'Tonnes',
    1: 'Cases',
    2: 'Eaches'
}

const sideViewTabs = {
    0: 'Global view',
    1: 'Shipment view'
}
const orderExecutionMonitorSideViewTabs = {
    0: 'Order To Allocation',
    1: 'Allocation To Delivery'
}
const TabbedView = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const getTabStorageKey = (path) => `tabbedView:${path}:tabValue`;
    const [tabValue, setTabValue] = useState(0);
    const { getPageAccessType, getUserType } = useUserAccess();
    const userType = getUserType();
    const { getRefreshDataByPage, setCurrentPageLabel, setCurrentSubPageLabel, formatRefreshTime, lastRefreshData } = useRefresh();
    const [sideTabIndex, setSideTabIndex] = useState(2); // Default to 'Eaches'
    const [sideViewTabIndex, setSideViewTabIndex] = useState(0); // Default to 'Global view'
    const PIPELINE_KEY = 'pipelineRefreshTime';
    const [qcommFilters, setQcomFilters] = useState({
        "Hands Free VMI": {},
        "Dispatch Priority": {},
        "PO Priority": {}
    });
    const [isExporting, setIsExporting] = useState(false);

    const handleFilterSelection = (screen, filterType, filterValue) => {
        console.log("Filter selected for", screen, ":", filterType, "=", filterValue);
        setQcomFilters(prevFilters => ({
            ...prevFilters,
            [screen]: {
                ...prevFilters[screen],
                [filterType]: filterValue
            }
        }));
    };

    const tabConfigs = {
        '/samarth/alert_details': {
            tabs: [
                { label: 'RMPM Alert', pageName: 'RMPM Autonomous Engine', component: <RmpmAlertLanding alertType="RMPM Alert" /> }
            ],
        },
        '/samarth/smart_production_scheduler': {
            tabs: [
                {
                    active: true,
                    label: 'Smart Production Scheduler',
                    pageName: 'Smart Production Scheduler',
                    component: () => (
                        <DailyPhasingProvider>
                            <DailyphasingContainer type="MM Screen Input" />
                        </DailyPhasingProvider>
                    )
                },
                {
                    label: 'DPR(Plan VS Actual)',
                    pageName: 'DPR(Plan Vs Actual)',
                    component: <DailyPhasingProvider><DailyPhasingLanding type="Daily Phasing" /></DailyPhasingProvider>
                },
                {
                    label: 'Prioritization Matrix',
                    pageName: 'Prioritization Matrix',
                    component: <PriortizationMatrix />
                },
                {
                    label: 'Daily Phasing insight',
                    pageName: 'Daily Phasing insight',
                    component: <DailyProductionInsight />
                },
            ],
        },
        '/samarth/plan_vs_actuals': {
            tabs: [
                {
                    label: 'Smart Production Scheduler',
                    pageName: 'Smart Production Scheduler',
                    component: () => (
                        <DailyPhasingProvider>
                            <DailyphasingContainer type="MM Screen Input" />
                        </DailyPhasingProvider>
                    )
                },
                {
                    active: true,
                    label: 'DPR(Plan VS Actual)',
                    pageName: 'DPR(Plan Vs Actual)',
                    component: <DailyPhasingProvider><DailyPhasingLanding type="Daily Phasing" /></DailyPhasingProvider>
                },
                {
                    label: 'Prioritization Matrix',
                    pageName: 'Prioritization Matrix',
                    component: <PriortizationMatrix />
                },
                {
                    label: 'Daily Phasing insight',
                    pageName: 'Daily Phasing insight',
                    component: <DailyProductionInsight />
                }
            ]
        },
        '/samarth/priortization_matrix': {
            tabs: [
                {
                    label: 'Smart Production Scheduler',
                    pageName: 'Smart Production Scheduler',
                    component: () => (
                        <DailyPhasingProvider>
                            <DailyphasingContainer type="MM Screen Input" />
                        </DailyPhasingProvider>
                    )
                },
                {
                    label: 'DPR(Plan VS Actual)',
                    pageName: 'DPR(Plan Vs Actual)',
                    component: <DailyPhasingProvider><DailyPhasingLanding type="Daily Phasing" /></DailyPhasingProvider>
                },
                {
                    active: true,
                    label: 'Prioritization Matrix',
                    pageName: 'Prioritization Matrix',
                    component: <PriortizationMatrix />
                },
                {
                    label: 'Daily Phasing insight',
                    pageName: 'Daily Phasing insight',
                    component: <DailyProductionInsight />
                }
            ]
        },
        '/samarth/daily_production_insights': {
            tabs: [
                {
                    label: 'Smart Production Scheduler',
                    pageName: 'Smart Production Scheduler',
                    component: () => (
                        <DailyPhasingProvider>
                            <DailyphasingContainer type="MM Screen Input" />
                        </DailyPhasingProvider>
                    )
                },
                {
                    label: 'DPR(Plan VS Actual)',
                    pageName: 'DPR(Plan Vs Actual)',
                    component: <DailyPhasingProvider><DailyPhasingLanding type="Daily Phasing" /></DailyPhasingProvider>
                },
                {
                    label: 'Prioritization Matrix',
                    pageName: 'Prioritization Matrix',
                    component: <PriortizationMatrix />
                },
                {
                    active: true,
                    label: 'Daily Phasing insight',
                    pageName: 'Daily Phasing insight',
                    component: <DailyProductionInsight />
                }
            ]
        },
        '/samarth/contract_alert': {
            tabs: [
                { label: 'Contract Coverage - Current Week', pageName: 'Cognitive Contract Coverage', component: <RmpmAlertLanding alertType="Contract Alert" /> },
                { label: 'Contract Coverage -  Future Weeks', pageName: 'Cognitive Contract Coverage', component: <RmpmAlertLanding alertType="Contract PR2 Alert" /> }
            ]
        },
        '/samarth/norm_alert': {
            tabs: [
                // { active: true, label: 'RMPM Analytics', pageName: 'RMPM Analytics', component: <RmpmAlertLanding alertType="Norm Alert" /> },
                { label: 'FG Demand', pageName: 'FG Demand', component: <RmpmDashboard /> },
            ]
        },
        '/samarth/demand': {
            tabs: [
                { label: 'RMPM Analytics', pageName: 'RMPM Analytics', component: <RmpmAlertLanding alertType="Norm Alert" /> },
                { active: true, label: 'FG Demand', pageName: 'FG Demand', component: <RmpmDashboard /> },
            ]
        },
        '/samarth/agile_or': {
            tabs: [
                { label: 'Agile OR', pageName: 'Agile OR', component: <RmpmAlertLanding alertType="Agile OR" /> }
            ]
        },
        '/samarth/supplier_insights': {
            tabs: [
                { label: 'Supplier Analytics', pageName: 'Supplier Analytics', component: <SupplierInsights alertType="Supplier Insights" /> }
            ]
        },
        '/samarth/weekly_or': {
            tabs: [
                { label: 'OR loss tree', pageName: 'OR Analytics', component: <OrLossTree alertType="Or Loss Tree" /> }
            ]
        },
        '/samarth/manpower_shortage': {
            tabs: [
                { label: 'Manpower Shortage', pageName: 'Manpower Shortage', component: <AlertLanding alertType="Manpower Shortage" /> }
            ]
        },
        '/samarth/admin_portal': {
            tabs: [
                { label: 'User', pageName: 'Admin Portal', component: <User /> },
                { label: 'Persona', pageName: 'Admin Portal', component: <Persona isSuperAdmin={userType === 'super admin'} /> }
            ]
        },
        '/samarth/ticket_portal': {
            tabs: [
                { label: 'Tickets', pageName: 'Ticket Portal', component: <Tickets /> },
            ]
        },

        '/samarth/order_visibility': {
            tabs: [
                { label: 'Hands Free VMI', pageName: 'Qcomm', sideTabValue: ['Tonnes', 'Cases', 'Eaches'], active: true, component: <OrderVisibility handleFilterSelection={handleFilterSelection} /> },
                { label: 'Dispatch Priority', pageName: 'Qcomm', sideTabValue: ['Tonnes', 'Cases', 'Eaches'], component: <DispatchPriority handleFilterSelection={handleFilterSelection} /> },
                { label: 'PO Priority', pageName: 'Qcomm', component: <POPriority handleFilterSelection={handleFilterSelection} /> }
            ]
        },
        '/samarth/dispatch_priority': {
            tabs: [
                { label: 'Hands Free VMI', pageName: 'Qcomm', sideTabValue: ['Tonnes', 'Cases', 'Eaches'], component: <OrderVisibility handleFilterSelection={handleFilterSelection} /> },
                { label: 'Dispatch Priority', pageName: 'Qcomm', sideTabValue: ['Tonnes', 'Cases', 'Eaches'], active: true, component: <DispatchPriority handleFilterSelection={handleFilterSelection} /> },
                { label: 'PO Priority', pageName: 'Qcomm', component: <POPriority handleFilterSelection={handleFilterSelection} /> }
            ]
        },
        '/samarth/po_priority': {
            tabs: [
                { label: 'Hands Free VMI', pageName: 'Qcomm', sideTabValue: ['Tonnes', 'Cases', 'Eaches'], component: <OrderVisibility handleFilterSelection={handleFilterSelection} /> },
                { label: 'Dispatch Priority', pageName: 'Qcomm', sideTabValue: ['Tonnes', 'Cases', 'Eaches'], component: <DispatchPriority handleFilterSelection={handleFilterSelection} /> },
                { label: 'PO Priority', pageName: 'Qcomm', active: true, component: <POPriority handleFilterSelection={handleFilterSelection} /> }
            ]
        },
        '/samarth/order_to_delivery_hub': {
            tabs: [
                { label: 'Order To Delivery Hub', pageName: 'PSO', active: true, component: <LossRecoveryEngine /> },
                { label: 'Order execution monitor', sideViewTabValue: ['Order to Allocation', 'Allocation to Delivery'], pageName: 'PSO', component: <OrderExecuationMonitor sideViewTab={orderExecutionMonitorSideViewTabs[sideViewTabIndex]} /> },
            ]
        },
        '/samarth/alert_summary': {
            tabs: [
                { label: 'RMPM Summary', pageName: 'PSO', active: true, component: <RMPMSummary /> },
                { label: 'Contract coverage summary', pageName: 'PSO', component: <LossRecoveryEngine /> }
            ]
        },
        '/samarth/loss_to_action_engine': {
            tabs: [
                // { label: 'INTR Recovery', pageName: 'PSO ', active: true, component: <INTRLossToAction /> },
                { label: 'INTR Recovery', pageName: 'PSO', component: <INTRLossToAction /> },

                { label: 'Unloading Prioritisation', pageName: 'PSO', component: <UnloadingPriority /> },
                { label: 'In-Transit Recovery', pageName: 'PSO', component: <InTransitRecovery /> },

                { label: 'Shipment Prioritisation', pageName: 'PSO', component: <DispatchPrioritisation /> },
                { label: 'Material View', pageName: 'PSO', component: <INTRMaterialView /> },
            ]
        },
        '/samarth/nr_replenishment_engine': {
            tabs: [
                { label: 'Smart Source Lens', pageName: 'FDC', active: true, component: <SmartSourceLens /> },
                { label: 'DC Supply Insights', pageName: 'FDC', component: <DcSupplyInsights /> },
            ]
        },
    };

    useEffect(() => {
        const allowedPaths = [
            "/samarth/smart_production_scheduler",
            "/samarth/plan_vs_actuals",
            "/samarth/priortization_matrix",
            "/samarth/daily_production_insights",
        ];
        if (!allowedPaths.includes(location.pathname)) {
            localStorage.removeItem("cbuLevelPlanFilters");
            localStorage.removeItem("lineCbuLevelPlanFilters");
            localStorage.removeItem("table_view_data");
        }
    }, [location.pathname])

    // Memoize current tab config to prevent unnecessary recalculations
    const currentTabConfig = useMemo(() => {
        const config = tabConfigs[location.pathname];
        if (!config) return { tabs: [] };

        // Update components with current sideTab value for Quick Comm pages
        if (location.pathname === '/samarth/order_visibility' || location.pathname === '/samarth/dispatch_priority') {
            return {
                ...config,
                tabs: config.tabs.map(tab => ({
                    ...tab,
                    component: React.cloneElement(tab.component, { sideTab: sideTabs[sideTabIndex] })
                }))
            };
        }

        // Update components with current sideViewTab value for Loss To Action Engine pages
        if (location.pathname === '/samarth/loss_to_action_engine') {
            return {
                ...config,
                tabs: config.tabs.map(tab => {
                    if (tab.sideViewTabValue) {
                        return {
                            ...tab,
                            component: React.cloneElement(tab.component, { sideViewTab: sideViewTabs[sideViewTabIndex] })
                        };
                    }
                    return tab;
                })
            };
        }

        return config;
    }, [location.pathname, sideTabIndex, sideViewTabIndex]);

    useEffect(() => {
        if (currentTabConfig.tabs.length === 0) {
            const findFirstValidPath = (menuItems) => {
                for (const item of menuItems) {
                    if (item.path) return item.path;
                    if (item.menus?.length > 0) {
                        const path = findFirstValidPath(item.menus);
                        if (path) return path;
                    }
                }
                return '/samarth';
            };

            const redirectPath = findFirstValidPath(MenuList);
            navigate(redirectPath);
        }
    }, [currentTabConfig.tabs.length, navigate]);

    useEffect(() => {
        const config = tabConfigs[location.pathname];
        if (!config?.tabs?.length) return;

        const pathsWithPersistedTabs = [
            "/samarth/loss_to_action_engine",
            "/samarth/order_to_delivery_hub",
            "/samarth/nr_replenishment_engine"
        ];

        if (pathsWithPersistedTabs.includes(location.pathname)) {
            const tabStorageKey = getTabStorageKey(location.pathname);
            const activeTabFromRoute = location.state?.activeTab;

            let nextTabValue = 0;

            if (
                typeof activeTabFromRoute === "number" &&
                activeTabFromRoute >= 0 &&
                activeTabFromRoute < config.tabs.length
            ) {
                nextTabValue = activeTabFromRoute;
            } else {
                const savedTabValue = sessionStorage.getItem(tabStorageKey);
                const parsedSavedTab =
                    savedTabValue !== null ? Number(savedTabValue) : null;

                if (
                    parsedSavedTab !== null &&
                    !Number.isNaN(parsedSavedTab) &&
                    parsedSavedTab >= 0 &&
                    parsedSavedTab < config.tabs.length
                ) {
                    nextTabValue = parsedSavedTab;
                } else {
                    const defaultActiveIndex = config.tabs.findIndex(tab => tab.active);
                    nextTabValue = defaultActiveIndex !== -1 ? defaultActiveIndex : 0;
                }
            }

            setTabValue(nextTabValue);
            return;
        }

        // Default logic for all other pages
        const activeTabFromRoute = location.state?.activeTab;

        if (
            typeof activeTabFromRoute === "number" &&
            activeTabFromRoute >= 0 &&
            activeTabFromRoute < config.tabs.length
        ) {
            setTabValue(activeTabFromRoute);
        } else {
            const defaultActiveIndex = config.tabs.findIndex(tab => tab.active);
            setTabValue(defaultActiveIndex !== -1 ? defaultActiveIndex : 0);
        }
    }, [location.pathname, location.state?.activeTab]);

    useEffect(() => {
        const pathsWithPersistedTabs = [
            "/samarth/loss_to_action_engine",
            "/samarth/order_to_delivery_hub"
        ];

        if (pathsWithPersistedTabs.includes(location.pathname)) {
            const tabStorageKey = getTabStorageKey(location.pathname);
            sessionStorage.setItem(tabStorageKey, String(tabValue));
        }
    }, [location.pathname, tabValue]);


    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);

        const tabStorageKey = getTabStorageKey(location.pathname);
        sessionStorage.setItem(tabStorageKey, String(newValue));

        const allowedPaths = [
            "/samarth/smart_production_scheduler",
            "/samarth/plan_vs_actuals",
            "/samarth/priortization_matrix",
            "/samarth/daily_production_insights",
        ];

        const quickCommPaths = [
            "/samarth/order_visibility",
            "/samarth/dispatch_priority",
            "/samarth/po_priority", // PO Priority - using dispatch_priority as placeholder
        ];

        // RMPM Analytics (Norm Alert) <-> FG Demand (RMPM Dashboard) tabs
        const rmpmAnalyticsPaths = [
            "/samarth/norm_alert",
            "/samarth/demand",
        ];

        if (allowedPaths.includes(location?.pathname)) {
            navigate(allowedPaths[newValue]);
        } else if (quickCommPaths.includes(location?.pathname)) {
            navigate(quickCommPaths[newValue]);
        } else if (rmpmAnalyticsPaths.includes(location?.pathname)) {
            navigate(rmpmAnalyticsPaths[newValue]);
        }
    };

    const handleSideTab = (event, newValue) => {
        console.log("Side tab changed to:", newValue);
        setSideTabIndex(newValue);
    };

    const handleSideViewTab = (event, newValue) => {
        console.log("Side view tab changed to:", newValue);
        setSideViewTabIndex(newValue);
    };

    // Display-only mapping: map internal labels to new visible text
    function getDisplayLabel(label) {
        if (!label) return label;
        if (label === 'Prioritization Matrix') return 'Dynamic Prioritization';
        return label;
    }

    useEffect(() => {
        if (currentTabConfig.tabs.length > 0 && currentTabConfig.tabs[tabValue]) {
            const activeTabLabel = currentTabConfig.tabs[tabValue].label;
            setCurrentPageLabel(getDisplayLabel(activeTabLabel));
            setCurrentSubPageLabel('');
        }
    }, [tabValue, currentTabConfig.tabs, setCurrentPageLabel, setCurrentSubPageLabel]);

    const pageName = useMemo(() => {
        const activeTab = currentTabConfig.tabs[tabValue];
        if (!activeTab) return;

        return activeTab.pageName;
    }, [tabValue, currentTabConfig.tabs]);

    const tabLabel = useMemo(() => {
        const activeTab = currentTabConfig.tabs[tabValue];
        if (!activeTab) return;
        return activeTab.label;
    }, [tabValue, currentTabConfig.tabs]);

    const currentPageRefreshData = useMemo(() => {
        return getRefreshDataByPage(tabLabel, '');
    }, [tabLabel, getRefreshDataByPage]);

    const isReadOnly = useMemo(() => {
        const accessType = getPageAccessType(pageName);
        return accessType === 'Read-Only';
    }, [pageName, getPageAccessType]);

    // Check for pipeline time changes on initial load
    useEffect(() => {
        if (lastRefreshData && lastRefreshData.length > 0 && tabLabel) {
            // Find matching page data from API based on Page field
            const matchingPageData = lastRefreshData.find(item => {
                if (!item?.Page) return false;
                const apiPageName = item.Page.trim();
                // Direct match or partial match
                return apiPageName === tabLabel || apiPageName.toLowerCase().includes(tabLabel.toLowerCase());
            });

            if (!matchingPageData || !matchingPageData.InsertedOn) return;

            const latestRefreshTime = matchingPageData.InsertedOn;
            const apiPageName = matchingPageData.Page;

            // Use API page name for localStorage key
            const pageSpecificKey = `${PIPELINE_KEY}_${apiPageName.replace(/[^a-zA-Z0-9]/g, '_')}`;
            const storedTime = localStorage.getItem(pageSpecificKey);

            if (!storedTime) {
                // First time load - store the time for this page
                localStorage.setItem(pageSpecificKey, latestRefreshTime);
            } else if (storedTime !== latestRefreshTime) {
                // Time has changed - refresh automatically
                // Update with new time
                localStorage.setItem(pageSpecificKey, latestRefreshTime);

                // Clear all localStorage except the pipeline time keys
                const keysToPreserve = Object.keys(localStorage).filter(key => key.startsWith(PIPELINE_KEY));
                const allKeys = Object.keys(localStorage);

                allKeys.forEach(key => {
                    if (!keysToPreserve.includes(key)) {
                        localStorage.removeItem(key);
                    }
                });

                // Force reload
                window.location.reload(true);
            }
        }
    }, [lastRefreshData, tabLabel]);

    usePageTracking(tabLabel);

    const hasSingleTab = currentTabConfig.tabs.length === 1;

    if (currentTabConfig.tabs.length === 0) {
        return null;
    }

    // Function to enhance components with refresh data props
    const renderComponentWithProps = (tab, index) => {
        const componentProps = {
            isReadOnly,
            isActive: tabValue === index,  // Add isActive prop so components know if they're visible
            key: `component-${index}`
        };

        if (typeof tab.component === "function") {
            return tab.component(componentProps);
        } else {
            return React.cloneElement(tab.component, componentProps);
        }
    };


    const handleExportQcomm = async (...tab) => {
        setIsExporting(true);
        try {
            const user_data = JSON.parse(localStorage.getItem('UserInfo'));
            const label = tab[1].label;
            const payload = {
                email: user_data?.user_info?.email,
                uom: sideTabs[sideTabIndex],
                filters: qcommFilters[label] || {},
                type: label
            };
            if (payload?.type === 'Hands Free VMI') {
                await handleAllSuggestedOrderExport(payload);
            } else if (payload?.type === 'Dispatch Priority') {
                await handleAllDispatchPriorityExport(payload);

            } else if (payload?.type === 'PO Priority') {
                await handleExportPOPriorityWholeScreen(payload);
            }
        } catch (error) {
            console.error("Export failed:", error);
        } finally {
            setIsExporting(false);
        }
    };

    return (
        <div className={styles.container} data-readonly={isReadOnly}>
            {isExporting && (
                <div className={styles.loaderOverlay}>
                    <div className={styles.loaderSpinner}></div>
                    <p className={styles.loaderText}>Exporting data, please wait...</p>
                </div>
            )}
            {!hasSingleTab && (
                <Box sx={{ borderBottom: 1, borderColor: '#1F36C7', ml: '15px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <CustomTabs
                        value={tabValue}
                        onChange={handleTabChange}
                        sx={{ '& .MuiTabs-flexContainer': { gap: '15px' } }}
                    >
                        {currentTabConfig.tabs.map((tab, index) => (
                            <CustomTab key={`tab-${index}`} label={getDisplayLabel(tab.label)} value={index} />
                        ))}
                    </CustomTabs>
                    {(currentTabConfig.tabs[tabValue]?.label) && (
                        tabLabel === 'DPR(Plan VS Actual)' && currentPageRefreshData.length > 0 ? (
                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                <div className={styles.refreshTime}>
                                    <span style={{ fontWeight: 500 }}> Last Refreshed - </span>
                                    DPR : {formatRefreshTime(
                                        currentPageRefreshData.find(item =>
                                            item.Page?.toLowerCase().includes('dpr'))?.InsertedOn) || ' '}
                                </div>
                                <div className={styles.refreshTime}>
                                    DFOS/EOL : {formatRefreshTime(
                                        currentPageRefreshData.find(item => item.Page?.toLowerCase().includes('dfos'))?.InsertedOn
                                    ) || ' '}
                                    {'  ||  '}
                                    SAP : {formatRefreshTime(
                                        currentPageRefreshData.find(item => item.Page?.toLowerCase().includes('sap'))?.InsertedOn
                                    ) || ' '}
                                </div>
                            </div>
                        ) : (
                            currentPageRefreshData.length > 0 ? ((location.pathname !== '/samarth/loss_to_action_engine'
                                &&
                                location.pathname !== '/samarth/nr_replenishment_engine'
                                &&
                                <div className={styles.refreshTime}>
                                    <span style={{ fontWeight: '500' }}>Last Refreshed -</span>{' '}
                                    {formatRefreshTime(
                                        [...currentPageRefreshData]
                                            .sort((a, b) => new Date(b.InsertedOn) - new Date(a.InsertedOn))[0]
                                            ?.InsertedOn // get the most recent date
                                    ) || ' '
                                    }
                                </div>
                            )
                            ) : " "
                        ))}

                    <div style={{ display: currentTabConfig.tabs[tabValue]?.["sideTabValue"] || currentTabConfig.tabs[tabValue]?.["sideViewTabValue"] ? 'flex' : 'none' }}>
                        {currentTabConfig.tabs[tabValue]?.["sideTabValue"] &&
                            <CustomTabs onChange={handleSideTab} value={sideTabIndex}>
                                {currentTabConfig.tabs[tabValue]?.["sideTabValue"].map((tab, idx) => (
                                    <CustomSideTab key={`side-tab-${idx}`} label={tab} value={idx} />
                                ))}
                            </CustomTabs>
                        }
                        {currentTabConfig.tabs[tabValue]?.["sideViewTabValue"] &&
                            <CustomTabs onChange={handleSideViewTab} value={sideViewTabIndex}>
                                {currentTabConfig.tabs[tabValue]?.["sideViewTabValue"].map((tab, idx) => (
                                    <CustomSideTab key={`side-view-tab-${idx}`} label={tab} value={idx} />
                                ))}
                            </CustomTabs>
                        }
                        {currentTabConfig.tabs[tabValue]?.["pageName"] === 'Qcomm' &&
                            <div style={{ marginLeft: '10px' }}>
                                <CustomButton icon={newExcel} label="Export" type="sideTabExcel" onClick={() => handleExportQcomm(sideTabIndex, currentTabConfig.tabs[tabValue])} />
                            </div>
                        }
                    </div>
                </Box>
            )}
            {currentTabConfig.tabs.map((tab, index) => (
                <CustomTabPanel key={`${location.pathname}-${index}`} value={hasSingleTab ? 0 : tabValue} index={index}>
                    {tabValue === index && renderComponentWithProps(tab, index)}
                </CustomTabPanel>
            ))}

            {/* Decision IQ Floating Chatbot for FG Stock Out pages */}
            {/* {['/samarth/order_to_delivery_hub', '/samarth/loss_to_action_engine', '/samarth/nr_replenishment_engine'].includes(location.pathname) && (
                <DecisionIQChatBot />
            )} */}
        </div>
    );
};

export default React.memo(TabbedView);